<template>
  <div
    class="blog"
    v-if="Object.keys(blogall).length > 0 && Object.keys(blogfirst).length > 0"
  >
    <section class="content-blog container">
      <div class="title">
        <h3 class="title-simple">{{ $t("pages.blog.ourtitle") }}</h3>
        <h1 class="title-strong">Blog</h1>
      </div>
      <div class="content-blog-items">
        <template v-if="Object.keys(blogfirst).length > 0">
          <div class="content-blog-items-highlighted">
            <div class="content-blog-items-highlighted-title d-none d-lg-flex">
              <h4>{{ $t("pages.hearth.indestaq") }}</h4>
            </div>
            <router-link
              class="blogfirst"
              tag="a"
              :to="{ name: 'BlogDetail', params: { slug: blogfirst.slug } }"
            >
              <div class="blogfirst-content-img">
                <div
                  class="blogfirst-content-img-bg"
                  v-if="blogfirst.thumbnails"
                  :style="{ backgroundImage: `url('${blogfirst.thumbnails}')` }"
                ></div>
                <div class="content-blog-items-highlighted-info">
                  <div class="content-blog-items-highlighted-info-geras">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36.421"
                      height="36.421"
                      viewBox="0 0 36.421 36.421"
                    >
                      <path
                        id="Caminho_66"
                        data-name="Caminho 66"
                        d="M7.007,15.56a1.4,1.4,0,0,1,1.96,0,1.4,1.4,0,0,1,.435,1.91,1.4,1.4,0,0,1-1.959,0,1.4,1.4,0,0,1-.435-1.91m11.686-1.106c1.105-1.244,2.342-2.427,3.485-3.622a.372.372,0,0,1,.521-.017l.393.362a.372.372,0,0,1,.025.522c-1.363,1.514-2.709,3.223-3.933,4.767-.168-.772-.338-1.45-.49-2.013m3.48,4.2a29.149,29.149,0,0,1,5.479-3.186.373.373,0,0,1,.5.183l.21.46a.371.371,0,0,1-.162.482,28.962,28.962,0,0,0-3.84,2.472,8.5,8.5,0,0,0-2.183-.411m-5.662,8.7a23.717,23.717,0,0,0-2.01-5.789.362.362,0,0,0-.287-.211c-2.439-.332-4.6-.6-7-.759a.372.372,0,0,1-.347-.386l.025-.6a.373.373,0,0,1,.385-.356c1.528.055,3.007.057,4.5.152.042,0,3.179.234,4.273,1.508.247.534.486,1.091.713,1.67.335.851-.124,3.78-.25,4.775m-3.456-8.547c-1.136-1.971-2.129-3.4-2.538-3.963a.37.37,0,0,1,.055-.5l.464-.411a.373.373,0,0,1,.521.026,25.633,25.633,0,0,1,3.475,4.931q.168.306.335.626a9.625,9.625,0,0,0-2.311-.713M19.344,7.818A1.4,1.4,0,0,1,20.36,9.494a1.4,1.4,0,0,1-1.408,1.362A1.4,1.4,0,0,1,17.936,9.18a1.4,1.4,0,0,1,1.408-1.362M29.916,6.5A16.555,16.555,0,1,0,6.5,29.916a5.572,5.572,0,0,0,.963.89c2.266,1.386,6.783.616,7.9.293.544-.157,1.045-.371,1.185-.92a32.024,32.024,0,0,0,.008-14.573,39.127,39.127,0,0,0-2.231-6.362.371.371,0,0,1,.156-.481l.528-.3a.372.372,0,0,1,.5.134,25.013,25.013,0,0,1,2.06,4.543,37.454,37.454,0,0,1,1.212,4.923H18.8c.129.793.23,1.617.294,2.464a.372.372,0,0,0,.629.24c.448-.433.886-.832,1.322-1.2a5.14,5.14,0,0,1,3.207.259l.04.017q.483.174.963.364c.213.091.34.153.342.154l.007-.014c1.269.513,2.526,1.083,3.775,1.6a.372.372,0,0,1,.2.479l-.168.428a.372.372,0,0,1-.474.213c-2.159-.792-4.514-1.459-6.649-2.115a.362.362,0,0,0-.354.075A22.813,22.813,0,0,0,19.358,23.7a.357.357,0,0,0-.087.222c-.007.151-.015.3-.023.443a28.867,28.867,0,0,0,.727,5.811,1.272,1.272,0,0,0,1.184.92c1.281.117,5.743,1.011,7.793-.293a6.028,6.028,0,0,0,.963-.89,16.555,16.555,0,0,0,0-23.411M18.21,0A18.211,18.211,0,1,1,5.334,5.334,18.154,18.154,0,0,1,18.21,0M31.173,18.873a1.571,1.571,0,0,0-3.017.534,1.571,1.571,0,0,0,3.017-.534"
                        fill="var( --green-medium)"
                      />
                    </svg>
                    <p>{{ $t("generic.gerasName") }}</p>
                  </div>
                  <div class="content-blog-items-highlighted-info-date">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="36.571"
                      viewBox="0 0 32 36.571"
                    >
                      <path
                        id="Caminho_65"
                        data-name="Caminho 65"
                        d="M28.571,4.571H25.143V.857A.86.86,0,0,0,24.286,0h-.571a.86.86,0,0,0-.857.857V4.571H9.143V.857A.86.86,0,0,0,8.286,0H7.714a.86.86,0,0,0-.857.857V4.571H3.429A3.429,3.429,0,0,0,0,8V33.143a3.429,3.429,0,0,0,3.429,3.429H28.571A3.429,3.429,0,0,0,32,33.143V8A3.429,3.429,0,0,0,28.571,4.571ZM3.429,6.857H28.571A1.146,1.146,0,0,1,29.714,8v3.429H2.286V8A1.146,1.146,0,0,1,3.429,6.857ZM28.571,34.286H3.429a1.146,1.146,0,0,1-1.143-1.143V13.714H29.714V33.143A1.146,1.146,0,0,1,28.571,34.286Zm-18-11.429H7.714A.86.86,0,0,1,6.857,22V19.143a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857V22A.86.86,0,0,1,10.571,22.857Zm6.857,0H14.571A.86.86,0,0,1,13.714,22V19.143a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857V22A.86.86,0,0,1,17.429,22.857Zm6.857,0H21.429A.86.86,0,0,1,20.571,22V19.143a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857V22A.86.86,0,0,1,24.286,22.857Zm-6.857,6.857H14.571a.86.86,0,0,1-.857-.857V26a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857v2.857A.86.86,0,0,1,17.429,29.714Zm-6.857,0H7.714a.86.86,0,0,1-.857-.857V26a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857v2.857A.86.86,0,0,1,10.571,29.714Zm13.714,0H21.429a.86.86,0,0,1-.857-.857V26a.86.86,0,0,1,.857-.857h2.857a.86.86,0,0,1,.857.857v2.857A.86.86,0,0,1,24.286,29.714Z"
                        fill="var( --green-medium)"
                      />
                    </svg>
                    <p>{{ this.blogfirst.date }}</p>
                  </div>
                </div>
              </div>
              <div class="content-blog-info">
                <div class="content-blog-info-title">
                  <h4 class="line-clamp">{{ blogfirst.title }}</h4>
                </div>
                <div class="content-blog-info-description">
                  <p
                    v-html="blogfirst.text"
                    class="content-blog-info-description-text line-clamp"
                  ></p>
                  <div class="content-blog-info-description-btn">
                    <router-link
                      tag="button"
                      :to="{
                        name: 'BlogDetail',
                        params: { slug: blogfirst.slug },
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10.034"
                        height="17.069"
                        viewBox="0 0 10.034 17.069"
                      >
                        <g
                          id="Grupo_1413"
                          data-name="Grupo 1413"
                          transform="translate(-5.534 8.534) rotate(-45)"
                        >
                          <path
                            id="União_2"
                            data-name="União 2"
                            d="M14.069,0,7.034,7.034ZM0,0,7.034,7.034Z"
                            transform="translate(0 9.948) rotate(-45)"
                            fill="none"
                            stroke="var( --green-medium)"
                            stroke-linejoin="round"
                            stroke-width="3"
                          />
                        </g>
                      </svg>
                    </router-link>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </template>
        <div class="content-blog-items-recent">
          <div class="content-blog-items-recent-title">
            <div class="content-blog-items-recent-title-text">
              <h4>{{ $t("generic.recents") }}</h4>
            </div>
            <router-link
              tag="button"
              :to="{ name: 'BlogList' }"
              class="content-blog-items-recent-title-btn"
            >
              {{ $t("generic.viewall") }}
            </router-link>
          </div>
          <div class="content-blog-items-recent-article">
            <template>
              <router-link
                v-for="(k, index) in blogall"
                :key="index"
                class="content-blog-items-recent-article-item"
                :to="{ name: 'BlogDetail', params: { slug: k.slug } }"
              >
                <div
                  class="content-blog-items-recent-article-item-img"
                  v-if="k.thumbnails && k.thumbnails.path"
                >
                  <img :src="k.thumbnails.path" alt="" />
                </div>
                <div class="content-blog-items-recent-article-item-text">
                  <h4 class="line-clamp">{{ k.title }}</h4>
                  <p v-html="k.text" class="line-clamp"></p>
                </div>
                <div class="content-blog-items-recent-article-item-btn">
                  <router-link
                    tag="button"
                    :to="{ name: 'BlogDetail', params: { slug: k.slug } }"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10.034"
                      height="17.069"
                      viewBox="0 0 10.034 17.069"
                    >
                      <g
                        id="Grupo_1413"
                        data-name="Grupo 1413"
                        transform="translate(-5.534 8.534) rotate(-45)"
                      >
                        <path
                          id="União_2"
                          data-name="União 2"
                          d="M14.069,0,7.034,7.034ZM0,0,7.034,7.034Z"
                          transform="translate(0 9.948) rotate(-45)"
                          fill="none"
                          stroke="var( --green-medium)"
                          stroke-linejoin="round"
                          stroke-width="3"
                        />
                      </g>
                    </svg>
                  </router-link>
                </div>
              </router-link>
            </template>
          </div>
        </div>
      </div>
    </section>
    <div class="button-mobile">
      <router-link tag="button" to="/">
        {{ $t("pages.hearth.more") }}
      </router-link>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      sliding: null,
      blogall: {},
      blogfirst: {},
    };
  },
  components: {},
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  async mounted() {
    axios
      .get("/api/v1/blog/first")
      .then((resp) => {
        if (resp && Object.keys(resp.data).length > 0) {
          this.blogfirst = resp.data;
          this.blogfirst.date = this.formatDate(this.blogfirst.created_at);
          this.blogfirst.thumbnails =
            this.blogfirst.thumbnails && this.blogfirst.thumbnails.path
              ? this.blogfirst.thumbnails.path
              : "";
        }
      })
      .catch((error) => {
        // this.errorMessage = error.message;
        console.error("There was an error!", error);
      });

    axios
      .post("/api/v1/blog/all")
      .then((resp) => {
        if (resp && resp.data) {
          this.blogall = resp.data;
        }
      })
      .catch((error) => {
        // this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
  },
};
</script>
<style lang="scss">
.blog {
  @media screen and (max-width: 991px) {
    margin-bottom: 10rem;
  }

  .content-blog {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      margin-bottom: 3rem;

      @media (max-width: 991px) {
        margin-bottom: 45px;
      }

      .title-simple {
        font-size: 50px;
        margin-bottom: 0;

        @media screen and (max-width: 991px) {
          font-size: 40px !important;
        }
      }

      .title-strong {
        font-size: 50px;
        margin-bottom: 0;

        @media screen and (max-width: 991px) {
          font-size: 40px !important;
        }
      }
    }

    &-items {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;

      @media screen and (max-width: 991px) {
        flex-direction: column;
      }

      .blogfirst {
        height: 601px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: 500ms;

        @media screen and (max-width: 991px) {
          height: auto;
          width: 100%;
        }

        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.8;
        }

        &-content-img {
          &-bg {
            display: block;
            width: 100%;
            height: 310px;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: cover !important;
            border-radius: 10px;
            transition: 500ms;
          }
        }
      }

      &-highlighted {
        width: 50%;
        display: flex;
        flex-direction: column;

        @media screen and (max-width: 991px) {
          width: 100%;
          height: auto;
          padding-right: 0;
        }

        &-title {
          margin-bottom: 30px;

          a {
            all: unset;

            &:hover,
            &:focus {
              all: unset;
            }
          }

          h4 {
            text-align: start;
            font-size: 28px;
            font-family: "Font Regular";
            color: var(--green-dark);
            margin-bottom: 0;

            @media screen and (max-width: 991px) {
              margin: 2rem 0;
              font-size: 28px;
            }
          }
        }

        &-info {
          display: flex;
          justify-content: space-between;
          color: var(--green-dark);
          font-family: "Font Regular";
          font-size: 1.375rem;
          margin: 30px 0;

          p {
            margin: 0;
            padding: 0;
            display: flex;
            align-items: center;
            font-size: 22px;

            @media screen and (max-width: 991px) {
              align-items: center;
            }
          }

          &-geras {
            display: flex;

            svg {
              margin-right: 1rem;

              @media screen and (max-width: 576px) {
                max-width: 32px;
              }
            }
          }

          &-date {
            display: flex;

            svg {
              margin-right: 1rem;

              @media screen and (max-width: 576px) {
                max-width: 32px;
                max-height: 36px;
              }
            }
          }
        }
      }

      &-recent {
        padding-left: 25px;
        width: 50%;
        display: flex;
        flex-direction: column;

        @media screen and (max-width: 991px) {
          width: 100%;
          height: auto;
          padding: 35px 0;
        }

        &-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 35px;

          &-text {
            h4 {
              text-align: start;
              font-size: 28px;
              font-family: "Font Regular";
              color: var(--green-dark);
              margin-bottom: 0;
            }
          }

          &-btn {
            background-color: #ffffff;
            width: 127px;
            height: 47px;
            color: var(--green-medium);
            border: 1px solid var(--green-medium);
            border-radius: 10px;
            font-size: 18px;
            font-family: "Font Bold", sans-serif;

            &:hover,
            &:focus {
              transition: all 0.5s ease;
              filter: drop-shadow(0 0 10px var(--green-medium));
            }

            @media screen and (max-width: 991px) {
              display: none;
            }
          }
        }

        &-article {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;

          &-item {
            position: relative;
            display: flex;
            margin-bottom: 25px;
            transition: 500ms;

            &:last-child {
              margin-bottom: 0;
            }

            &:hover,
            &:focus {
              cursor: pointer;
              opacity: 0.8;
            }

            &-text {
              color: #112d23;
              text-align: start;
              padding: 0 1rem 0 2rem;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: calc(100% - 50px);

              @media (max-width: 991px) {
                padding: 0 0 0 2rem;
              }

              h4 {
                font-size: 24px;
                font-family: "Font Bold";
                margin-bottom: 1rem;

                @media screen and (max-width: 991px) {
                  font-size: 20px;
                  margin-bottom: 2rem;
                }
              }

              p {
                max-width: calc(100% - 40px);
                font-size: 18px;
                font-family: "Font Regular";
                padding-bottom: 0;
                margin-bottom: 0;

                @media screen and (max-width: 991px) {
                  font-size: 18px;
                }
              }

              .line-clamp {
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }

              .date {
                margin-bottom: 10px;

                span {
                  font-size: 18px;
                  font-family: "Font Regular";
                  color: var(--green-dark);
                  margin-left: 10px;
                }
              }
            }

            &-btn {
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
              position: absolute;
              right: 0;
              bottom: 0;

              button {
                background-color: #ffffff;
                width: 56px;
                height: 41px;
                color: #fff;
                border: 1px solid var(--green-medium);
                border-radius: 10px;

                &:hover,
                &:focus {
                  transition: all 0.5s ease;
                  filter: drop-shadow(0 0 10px var(--green-medium));
                }

                @media screen and (max-width: 991px) {
                  position: absolute;
                  bottom: 0;
                  right: 1rem;
                  width: 40px;
                  height: 29px;
                  border-radius: 7px;

                  svg {
                    width: 10px;
                    height: 10px;
                  }
                }
              }

              svg {
                @media screen and (max-width: 576px) {
                  max-width: 7px;
                  height: 15px;
                }
              }
            }

            &-img {
              img {
                border-radius: 10px;
                width: 170px;
                height: 128px;
                object-fit: cover;

                @media (max-width: 991px) {
                  width: 112px;
                }
              }
            }
          }
        }
      }
    }

    &-info {
      width: 100%;
      &-title {
        color: var(--green-dark);
        width: 100%;
        margin: 3rem 0;
        text-align: start;

        @media screen and (max-width: 991px) {
          margin: 0 0 20px 0;
        }

        a {
          all: unset;

          &:hover,
          &:focus {
            all: unset;
          }
        }

        h4 {
          font-size: 30px;
          font-family: "Font Bold";
          color: var(--green-dark);
          margin-bottom: 0;

          @media screen and (max-width: 991px) {
            font-size: 20px;
          }
        }
      }

      &-description {
        text-align: start;
        font-size: 22px;
        font-family: "Font Regular";
        margin-top: 3rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media screen and (max-width: 991px) {
          text-align: justify;
          margin: 0;
        }

        &-text {
          font-size: 22px;
          font-family: "Font Regular";
          color: var(--green-dark);
          text-align: left;
          margin-bottom: 0;

          @media screen and (max-width: 991px) {
            margin-right: 0;
            font-size: 18px;
          }
        }

        &-btn button {
          background-color: #ffffff;
          border: 1px solid var(--green-medium);
          width: 72px;
          height: 53px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover,
          &:focus {
            transition: all 0.5s ease;
            filter: drop-shadow(0 0 10px var(--green-medium));
          }
        }
      }
    }
  }

  .button-mobile {
    display: none;

    @media screen and (max-width: 991px) {
      all: unset;
      display: flex;
      margin-top: 20px;
      align-items: center;
      justify-content: center;

      button {
        width: 128px;
        height: 47px;
        border: 1px solid var(--green-medium);
        background-color: #fff;
        border-radius: 10px;
        font-size: 18px;
        font-family: "Font Bold", sans-serif;
        color: var(--green-medium);

        &:hover,
        &:focus {
          transition: all 0.5s ease;
          filter: drop-shadow(0 0 10px var(--green-medium));
        }
      }
    }
  }
}
</style>
